export const Code = (props: {children: string, className?: string}) => {
  const whitespaceToTrim = props.children.match(/^\n?(\s+)/) // Get the whitespace at the beginning of the string
  const whiteSpaceLen = (whitespaceToTrim?.[0]?.length || 1) - 1

  const formatRegex = new RegExp(`\n\\s{${whiteSpaceLen}}`, 'g')
  const formatted = props.children.replace(formatRegex, '\n')

  let className = 'block bg-gray-100 p-2 rounded-md text-sm'
  if (props.className) {
    className += ' ' + props.className
  }

  return (
    <code className={className}><pre>{formatted}</pre></code>
  )
}